import { combineReducers } from "redux"
import { chain } from "lodash"
import user from "./user"
import modules from "modules/reducer"
import global from "model/reducer"

const dashboard = combineReducers({
  // _placeholder satisfies combineReducers until the first real slice lands in PR 2.
  _placeholder: (state = null) => state,
})

function getReducer(directory, paths) {
  return combineReducers(
    chain(paths.keys())
      .map(path => path.substr(2, path.length - 5))
      .map(path => [path, require(`${directory}/${path}.js`).default])
      .fromPairs()
      .value(),
  )
}

export default combineReducers({
  user,
  app: getReducer("./app", require.context("./app", false, /.js/)),
  modules,
  global,
  dashboard,
})
